module.exports = __webpack_public_path__ + "img/teilor-map-of-europe.3b53ad3c.png";